import {
  formatSimilarityStat,
  getSimilarSeasonPath,
} from "./similarSeasonsFormat";
import { similarityFeatureDisplay } from "./similarSeasonsFeatureGlossary";

const DEFAULT_DISPLAY = {
  statLabel: (_metric, fallback) => fallback,
  formatStat: formatSimilarityStat,
  teamLabel: (teamId) => teamId || null,
  teamLogoId: (teamId) => teamId || null,
};

export function similarSeasonRankLabel(rank) {
  if (rank === 1) return "Closest statistical match";
  if (rank <= 3) return "Strong match";
  return "Similar profile";
}

export function similarSeasonTooltip(rank) {
  return `${similarSeasonRankLabel(rank)}. Closer rank means a closer stat profile, not a more famous player.`;
}

export function toSimilarSeasonItem(
  match,
  rank,
  league,
  display = DEFAULT_DISPLAY,
  pathOptions
) {
  const strongest = (match.strongestMatches || []).slice(0, 4);
  const featureFor = (row) =>
    similarityFeatureDisplay(row.metric, row.label || row.metric);
  const strongestFeatures = strongest.map((row) => {
    const feature = featureFor(row);
    return { label: feature.label, gloss: feature.gloss };
  });
  return {
    key: `${match.playerId}-${match.season}`,
    href: getSimilarSeasonPath(league, match.playerId, match.season, pathOptions),
    playerId: match.playerId,
    sport: league,
    playerName: match.playerName || match.playerId,
    season: match.season,
    teamId: match.teamId || null,
    teamLabel: display.teamLabel(match.teamId),
    teamLogoId: display.teamLogoId(match.teamId),
    rank,
    rankLabel: similarSeasonRankLabel(rank),
    tooltip: similarSeasonTooltip(rank),
    strongestLabels: strongestFeatures.map((feature) => feature.label),
    strongestFeatures,
    comparisons: strongest.map((row) => {
      const feature = featureFor(row);
      return {
        label: feature.label,
        source: feature.format(row.source),
        match: feature.format(row.match),
      };
    }),
  };
}

export function toSimilarSeasonItems(results = [], league, display, pathOptions) {
  return results.map((match, index) =>
    toSimilarSeasonItem(match, index + 1, league, display, pathOptions)
  );
}
